import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';

export interface DefaultCustomOrderTypeInput {
  readonly checkoutDeliverySelectionEnabled: boolean;
  readonly hasCollectAtStoreCart: boolean;
  readonly hasHomeDeliveryCart: boolean;
  readonly isClickAndCollectAllowedForStore: boolean;
  readonly isHomeDeliveryPossible: boolean;
  readonly isPreOrderActive: boolean;
  readonly isSwitzerland: boolean;
  readonly latestSelectedDeliveryMethod: CustomOrderType;
}

export const computeDefaultCustomOrderType = ({
  checkoutDeliverySelectionEnabled,
  hasCollectAtStoreCart,
  hasHomeDeliveryCart,
  isClickAndCollectAllowedForStore,
  isHomeDeliveryPossible,
  isPreOrderActive,
  isSwitzerland,
  latestSelectedDeliveryMethod
}: DefaultCustomOrderTypeInput): CustomOrderType => {
  return checkoutDeliverySelectionEnabled
    ? isSwitzerland || (!hasHomeDeliveryCart && hasCollectAtStoreCart)
      ? CustomOrderType.COLLECT_AT_STORE
      : CustomOrderType.HOME_DELIVERY
    : (isHomeDeliveryPossible &&
          (latestSelectedDeliveryMethod === CustomOrderType.HOME_DELIVERY ||
            !isClickAndCollectAllowedForStore)) ||
        isPreOrderActive
      ? CustomOrderType.HOME_DELIVERY
      : CustomOrderType.COLLECT_AT_STORE;
};
